import { User, UserDetail } from '@/entities/user';
import { USER_ROLE_ADMINISTRATOR } from '.';

export function intoEditable(data: UserDetail): User {
  return {
    ...data.data,
    // eslint-disable-next-line no-nested-ternary
    role: data.data.admin
      ? USER_ROLE_ADMINISTRATOR
      : (data.data.role ? data.data.role.id : null),
    entityItems: data.data.entityItems.map(entityItem => entityItem.id),
    entityFolders: data.data.entityFolders.map(entityFolder => entityFolder.id),
    groups: data.data.groups.map(group => group.id),
    invite: false,
    password: null,
  };
}

export function fromEditable(data: User): User {
  const editableData = {
    ...data,
    admin: data.role === USER_ROLE_ADMINISTRATOR || data.role === null,
    role: data.role === USER_ROLE_ADMINISTRATOR ? null : data.role,
  };

  //do not send password if invite
  if (data.invite) {
    delete editableData.password;
  }

  return editableData;
}
